import { MultiSelect } from "primereact/multiselect";
import { RadioButton } from "primereact/radiobutton";
import classes from '../SitesOnSchedule/sitesOnScheduleSearchBar.module.css'
import { useEffect, useState } from "react";
import filters from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/filters.png'
import exportIcon from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/export.png'

import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";

const PadlocksSearchbar = (props) => {

    const { placeholder, onChange, value, handleFocus, handleBlur, setCategoryFilter, showFilterButton, reset, groups, selectedGroupFilter, setSelectedUsedByGroupFilter, setSelectedOwnedByGroupFilter, setSelectedBilledToGroupFilter, selectedFilter, setSelectedFilter, sortBy, setSortBy, portalSiteNameFilter, setPortalSiteNameFilter, includes, setIncludes, handleExport, unlinkedOnly, setUnlinkedOnly, isGateways, isSensors, setBatteryFilter, setSignalFilter, setStatusFilter, sensorTypeFilter, setSensorTypeFilter} = props;
    const [showFilters, setShowFilters] = useState(false);
    const [localSortBy, setLocalSortBy] = useState("")
    const [localSelectedFilter, setLocalSelectedFilter] = useState("")
    const [localSelectedBilledToGroupFilter, setLocalSelectedBilledToGroupFilter] = useState("")
    const [localSelectedOwnedByGroupFilter, setLocalSelectedOwnedByGroupFilter] = useState("")
    const [localSelectedUsedByGroupFilter, setLocalSelectedUsedByGroupFilter] = useState("")
    const [localIncludes, setLocalIncludes] = useState()
    const [localUnlinkedOnly, setLocalUnlinkedOnly] = useState(false)
    const [localPortalSiteNameFilter, setLocalPortalSiteNameFilter] = useState(portalSiteNameFilter)
    const [localStatus, setLocalStatus] = useState("")
    const [localBattery, setLocalBattery] = useState("")
    const [localSignal, setLocalSignal] = useState("")
    const [localSensorType, setLocalSensorType] = useState("")

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    const handleClear = () => {
        onChange({ target: { value: '' } }); 
    };

    const handleShowFilters = () => {
        setShowFilters(prev => !prev);
    };

    const HandleResetFilters = () => {
        setSelectedFilter("")
        setSortBy("")
        setSelectedOwnedByGroupFilter("")
        setSelectedUsedByGroupFilter("")
        setSelectedBilledToGroupFilter("")
        setPortalSiteNameFilter("")
        setIncludes(true)
        setUnlinkedOnly(false)
        setStatusFilter("")
        setBatteryFilter("")
        setSignalFilter("")

        setLocalSelectedFilter("")
        setLocalSortBy([])
        setLocalSelectedBilledToGroupFilter([])
        setLocalSelectedOwnedByGroupFilter([])
        setLocalSelectedUsedByGroupFilter([])
        setLocalPortalSiteNameFilter("")
        setLocalIncludes(true)
        setLocalUnlinkedOnly(false)
        setLocalStatus("")
        setLocalBattery("")
        setLocalSignal("")
        setLocalSensorType("")
        if (setSensorTypeFilter) setSensorTypeFilter("")

        setShowFilters(false)
    }


    useEffect(() => {
        if (reset > 0){
        HandleResetFilters()
        }
    }, [reset])

    const HandleApplyFilters = () => {
        setSelectedOwnedByGroupFilter(localSelectedOwnedByGroupFilter)
        setSelectedUsedByGroupFilter(localSelectedUsedByGroupFilter)
        setSelectedBilledToGroupFilter(localSelectedBilledToGroupFilter)
        setSelectedFilter(localSelectedFilter)
        setSortBy(localSortBy)
        setPortalSiteNameFilter(localPortalSiteNameFilter)
        setUnlinkedOnly(localUnlinkedOnly)
        setIncludes(localIncludes)
        setBatteryFilter(localBattery)
        setStatusFilter(localStatus)
        setSignalFilter(localSignal)
        if (setSensorTypeFilter) setSensorTypeFilter(localSensorType)

        setShowFilters(false)
    }
    
    const sorts = [
        "Billable",
        "Not billable"
    ]

    const options = [
        "Battery level asc",
        "Battery level desc",
        isGateways ? "Last seen (newest -> oldest)" : "Last read (newest -> oldest)",
        isGateways ? "Last seen (oldest -> newest)" : "Last read (oldest -> newest)",
        isGateways ? "Date added (newest -> oldest)" : "Registered (newest -> oldest)",
        isGateways ? "Date added (oldest -> newest)" : "Registered (oldest -> newest)",
        "Owner A-Z",
        "Owner Z-A",
        "Billed to A-Z",
        "Billed to Z-A",
        "Used by A-Z",
        "Used by Z-A"
    ]

    const statusOptions = [
        "Online",
        "Offline",
        "Missed check-in"
    ]

    const batteryOptions = [
        "Low battery",
        "Warning",
        "Healthy"
    ]

    const signalOptions = [
        "Poor",
        "Fair",
        "Good"
    ]

    const sensorTypeOptions = [
        "SigFox lite contact",
        "SigFox industrial contact",
        "Standalone NB-IOT Sensor",
        "BLE Sensor"
    ]

    const handleInputChange = (e) => {
        setLocalPortalSiteNameFilter(e.target.value); // For debugging
    };

    const handleUnlinked = () => {
        setLocalUnlinkedOnly(!localUnlinkedOnly)
    }

    const handleSetExcludes = () => {
        setLocalIncludes(false)
    }

    return (
      <div className={classes.searchContainer}>
          <input
              className={classes.searchBar}
              placeholder={placeholder}
              value={value}
              onKeyPress={handleKeyPress}
              onChange={onChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              spellCheck={false}
          />

          <div className={classes.buttonGroup}>
              {value && (
                  <button className={classes.clearButton} onClick={handleClear} type="button">
                      ×
                  </button>
              )}
              { <button className={classes.filterButton} >
                  <img onClick={handleShowFilters} type="button" style={{ height: '30px', width: '30px' }} src={filters}/>
                  <img onClick={handleExport} style={{ height: '30px', width: '30px', marginLeft:"10px" }} src={exportIcon}/>
              </button>}
          </div>

          {showFilters && (
                <div className={classes.filterDropdown}>
                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Sort by:</label>
                        <Dropdown
                            value={localSortBy}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalSortBy(e.value)}
                            options={options}
                            placeholder="Sorting method"
                            checkmark
                            highlightOnSelect
                        />
                    </div>
                  <br></br>

                  {isGateways && 
                  <>
                  <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Status: </label>
                        <Dropdown
                            value={localStatus}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalStatus(e.value)}
                            options={statusOptions}
                            placeholder="Gateway status"
                            checkmark
                            highlightOnSelect
                        />
                    </div> 
                    <br/>

                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Battery level: </label>
                        <Dropdown
                            value={localBattery}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalBattery(e.value)}
                            options={batteryOptions}
                            placeholder="Battery level"
                            checkmark
                            highlightOnSelect
                        />
                    </div> 
                    <br/>

                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Signal strength: </label>
                        <Dropdown
                            value={localSignal}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}  
                            onChange={(e) => setLocalSignal(e.value)}
                            options={signalOptions}
                            placeholder="Signal strength"
                            checkmark
                            highlightOnSelect
                        />
                    </div> 
                    <br/>
                  </>
                  
                    
                    }
                    
                    {isSensors && (
                        <>
                        <div className={classes.filterRow}>
                            <label className={classes.filterLabel}>Sensor type:</label>
                            <Dropdown
                                value={localSensorType}
                                className="w-full md:w-14rem"
                                style={{ width: '400px' }}
                                onChange={(e) => setLocalSensorType(e.value ?? "")}
                                options={sensorTypeOptions}
                                placeholder="All sensor types"
                                showClear
                                checkmark
                                highlightOnSelect
                            />
                        </div>
                        <br/>
                        </>
                    )}

                    { <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Billing status:</label>
                        <Dropdown 
                          value={localSelectedFilter} 
                          onChange={(e) => setLocalSelectedFilter(e.value)} 
                          options={sorts} 
                          placeholder="Select filters" 
                          className="w-full md:w-14rem"
                          style={{ width: '400px' }} />
                    </div>}

                    <br></br>
                    <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Owned by:</label>
                        <Dropdown
                            value={localSelectedOwnedByGroupFilter}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}
                            onChange={(e) => setLocalSelectedOwnedByGroupFilter(e.value)}
                            options={[
                                { label: "— Not set —", value: "__UNSET__" },
                                ...groups.map((group) => ({ label: group.name, value: group.name })).sort((a, b) => a.label.localeCompare(b.label))
                            ]}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Choose group"
                            filter
                            filterPlaceholder="Search groups..."
                        />
                    </div>

                    <br></br>

                    { <div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Used by:</label>
                        <Dropdown
                            value={localSelectedUsedByGroupFilter}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}
                            onChange={(e) => setLocalSelectedUsedByGroupFilter(e.value)}
                            options={[
                                { label: "— Not set —", value: "__UNSET__" },
                                ...groups.map((group) => ({ label: group.name, value: group.name })).sort((a, b) => a.label.localeCompare(b.label))
                            ]}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Choose group"
                            filter
                            filterPlaceholder="Search groups..."
                        />
                    </div>}

                    <br></br>

                    { (localSelectedFilter != "Not billable") && (<div className={classes.filterRow}>
                        <label className={classes.filterLabel}>Billed to:</label>
                        <Dropdown
                            value={localSelectedBilledToGroupFilter}
                            className="w-full md:w-14rem"
                            style={{ width: '400px' }}
                            onChange={(e) => setLocalSelectedBilledToGroupFilter(e.value)}
                            options={[
                                { label: "— Not set —", value: "__UNSET__" },
                                ...groups.map((group) => ({ label: group.name, value: group.name })).sort((a, b) => a.label.localeCompare(b.label))
                            ]}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Choose group"
                            filter
                            filterPlaceholder="Search groups..."
                        />
                    </div>)}

                   
                      
                    {!isGateways && <div className="flex align-items-center">
                        <Checkbox  name="includes" value="Includes" onChange={handleUnlinked} checked={localUnlinkedOnly == true} />
                        <label style={{marginLeft:"8px"}} htmlFor="includes" className="ml-2">Show unlinked padlocks only</label>
                    </div>}
                    


                    <div className={classes.buttonRow}>
                      <Button icon="pi pi-refresh" type="button" style={{marginRight:"15px"}} label="Reset filters" onClick={HandleResetFilters} outlined severity='danger'/>
                      <Button  icon="pi pi-check" type="button" label="Apply" onClick={HandleApplyFilters}/>
                    </div>
                </div>
            )}
      </div>
    );
}

export default PadlocksSearchbar;